export class AnalyticsDataEntityModel {
    /**
     * 自分のAnalyticsHash
     */
    analytics_hash: string | undefined = undefined;

}
